import React from 'react';
import styled from 'styled-components'
import Link from "gatsby-link";

const SiteLink = styled(Link)`
  color: #3a87ad;
`;

export default SiteLink



// WEBPACK FOOTER //
// ./src/components/Link.js